import { memo } from "react";

/**
 * Lightweight SVG sparkline. Smooth-ish polyline through the values.
 * Designed for small inline charts (no axes, no labels).
 */
function SparklineImpl({ values, color = "#16A34A", width = 200, height = 40, strokeWidth = 2 }) {
  if (!values || values.length < 2) {
    // Render an invisible placeholder of the same size to avoid layout shift.
    return <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" />;
  }

  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const stepX = width / (values.length - 1);

  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / span) * (height - strokeWidth) - strokeWidth / 2;
    return [x, y];
  });

  const path = points
    .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`)
    .join(" ");

  return (
    <svg
      width="100%"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      role="img"
      aria-label="7-day price sparkline"
    >
      <path
        d={path}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}

const Sparkline = memo(SparklineImpl);
export default Sparkline;
